goog.provide('el8.appchart.letters.attachmentGroups');

goog.require('el8.appchart.reportFeeds.contentRenderer');
goog.require('el8.appchart.reportFeeds.renderer');
goog.require('el8.data.educationalHandouts');
goog.require('el8.ptdata.fetch');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.reportFeeds');
goog.require('el8.uiwidget.Feed');
goog.require('el8.uiwidget.FilterableFeed');
goog.require('el8.uiwidget.ClientConstructedFeed');
goog.require('el8.util.consts');

/**
 * This file defines the input to the GroupedNav widget for the selectAttachment.js dialog
 * (i.e., the list of feeds that make up the attachment dialog).
 */
el8.appchart.letters.attachmentGroups = (function() {

    var isAttachedFn = null; // used to check with selectAttachments if an item should be rendered selected

    var feedList = {};

    function createAttachmentFeed(spec) {
        var name = spec.name;

        // The feed will show async, so if the user switches tabs before the feed renders,
        // we can get a race condition where feed A is fetching, we switch to feed B, which hides
        // feed A, but then feed A finishes fetching and shows itself again. Making the feed
        // container a div inside the main container prevents this.
        var $groupContainer = spec.container;
        $groupContainer.html(el8.template.appchart.letters.selectAttachments.groupFeedContainer());
        var $feedContainer = $('.grouped-nav-feed', $groupContainer);

        var constructorArgs = {
            container: $feedContainer,
            name: name,
            urlIndex: spec.url,
            preProcessIndexFn: spec.preProcessFeedFn,
            emptyMsg: 'No items to be displayed',
            rendererFn: function(item) {
                var mClass = item.getModelClass();
                if (_.contains(el8.data.attachablePrintouts, mClass)) {
                    return function(item, feedId) {
                        return el8.template.appchart.letters.selectAttachments.feedElem({
                            feedId: feedId,
                            feedItemId: mClass+'_0',
                            attachment: { modelClass: mClass, id: mClass },
                            isAttached: isAttachedFn(mClass)
                        });
                    };
                } else {
                    return function(item, feedId) {
                        return el8.template.appchart.letters.selectAttachments.feedElem({
                            feedId: feedId,
                            feedItemId: item.getFeedItemId(),
                            attachment: item.asSoyMap(),
                              //we need different styling if this item is already selected
                            isAttached: isAttachedFn(mClass, item)
                        });
                    };
                }
            },
            fetchFn: spec.fetchFn || el8.ptdata.fetch,
            pageSize: el8.util.consts.REPORT_FEED_PAGESIZE,
            navMode: 'feed',
            moreTrigger: '#attachment-feed-'+name+'-more-btn',
            skeletonFn: function(spec) {
                spec = spec || {};
                spec['buttonId'] = 'attachment-feed-'+name+'-more-btn';
                return el8.template.appchart.reportFeeds.feed(spec);
            },
            contentWrapperClass: 'overlayFeedItem',
            feedDateFn: function(item) { return item.getDocumentDate(); }
        };
        if (spec.urlFilter) {
            $.extend(constructorArgs, {
                urlFilter: spec.urlFilter,
                filterFieldSelector: spec.filterFieldSelector,
                filterFieldInfoText: spec.filterFieldInfoText,
                filterBtn: spec.filterBtn,
                clearFilterBtn: spec.clearFilterBtn,
                filteredClass: spec.filteredClass
            });
            $feedContainer.append(el8.template.appchart.letters.selectAttachments.searchBar());
        }
        if (spec.fixedIndex) {
            $.extend(constructorArgs, {
                fixedIndex: spec.fixedIndex
            });
        }

        var FeedConstructor = el8.uiwidget.Feed;
        if (spec.urlFilter) { FeedConstructor = el8.uiwidget.FilterableFeed; }
        if (spec.fixedIndex) { FeedConstructor = el8.uiwidget.ClientConstructedFeed; }
        var feed = new FeedConstructor(constructorArgs);

        feedList[name] = feed;
    }

    function createAttachmentReportFeed($container, name) {
        var rType = el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[name];
        var url = el8Globals['PATIENT_PATH']+'report-feed-index/'+rType.id+'/?attachable=1';
        createAttachmentFeed({
            container: $container,
            name: name,
            url: url
        });
    }

    function createAttachmentOrderFeed($container, name) {
        var urlName = name.split('-')[0];
        var url = el8Globals['PATIENT_PATH']+'order-feed-index/'+urlName+'/';
        createAttachmentFeed({
            container: $container,
            name: name,
            url: url
        });
    }

    function tabShowFn($container, name) {
        if (feedList[name]) {
            feedList[name].display();
        }
    }


    // attachable order models (we don't want to include MedOrders or DenialMedOrders)
    var ORDER_MODELS = ['ReferralOrder', 'LabOrder', 'ImagingOrder', 'CardiacOrder', 'PulmonaryOrder', 'SleepOrder'];

    return {
        groups: function() {
            var result = [
                {
                    title: 'Most Recent',
                    sections: [
                        {
                            name: 'popular',
                            label: 'Most Recent',
                            initFn: function($container, name) {
                                createAttachmentFeed({
                                    container: $container,
                                    name: name,
                                    url: el8Globals['PATIENT_PATH'] + 'chart-feed-index/',
                                    fetchFn: function(arg, force, async, callbackFn) {

                                        if (!(arg instanceof Array)) { arg = [arg]; }

                                        /* Assume that if 'id' key isn't a number, then it's not a ptdata item to fetch */
                                        var ptdataArgs = _.filter(arg, function(a) { return !isNaN(a['id']); });
                                        var results = el8.ptdata.fetch(ptdataArgs, force, async, callbackFn);

                                        var idArgs = _.pluck(arg, 'id');
                                        var printouts = [];
                                        el8.data.attachablePrintouts.forEach(function(name) {
                                            if (_.contains(idArgs, name)) {
                                                printouts.push({
                                                    getId: function() { return name; },
                                                    getModelClass: function() { return name; }
                                                });
                                            }
                                        });

                                        /* Assume printouts are always at the top of the list */
                                        return printouts.concat(results);
                                    },
                                    preProcessFeedFn: function(index) {
                                        var filteredIndex = [];
                                        el8.data.attachablePrintouts.forEach(function(name) {
                                            if (!name.endswith('Chart')) {
                                                filteredIndex.push({ id: name });
                                            }
                                        });
                                        for (var i=0, len=index.length; i < len; i++) {
                                            var feedItem = index[i];
                                            // add the most recent local VisitNote, then stop
                                            if (feedItem.model_class.match(/^VisitNote[2]?$/) !== null &&
                                                el8.util.isNone(feedItem.document_sub_type)) {
                                                    if (feedItem.model_class === "VisitNote2") {
                                                        // Chart feed index includes VN1s and VN2s, but not backported VN1s
                                                        // Filter for VN1 notes and VN2 backports, as we only support attachments for VN1.
                                                        // For the case of VN2s we'll instead surface the backported VN1
                                                        // el8.ptdata.fetch will fetch the backported VN1 if not cached
                                                        filteredIndex.push({ id: feedItem.note_v1_id });
                                                    } else {
                                                        filteredIndex.push(feedItem);
                                                    } 

                                                    break;
                                            }
                                            // until we see our first VisitNote, add any Reports/Orders/Imported Notes
                                            if (feedItem.model_class.indexOf('Report') !== -1 ||
                                                (feedItem.model_class.indexOf('Note') !== -1 && feedItem.document_sub_type) ||
                                                _.contains(ORDER_MODELS, feedItem.model_class)) {
                                                    filteredIndex.push(feedItem);
                                            }
                                        }
                                        return filteredIndex;
                                    }
                                });
                            },
                            showFn: tabShowFn
                        },
                        {
                            name: 'growthcharts',
                            label: 'Growth Charts',
                            initFn: function($container, name) {
                                createAttachmentFeed({
                                    container: $container,
                                    name: name,
                                    fixedIndex: _.filter(el8.data.attachablePrintouts, function(name) {
                                        return (name.endswith('Chart'));
                                    }),
                                    fetchFn: function(arg, force, async, callbackFn) {

                                        if (!(arg instanceof Array)) { arg = [arg]; }

                                        var printouts = [];
                                        arg.forEach(function(name) {
                                            if (_.contains(el8.data.attachablePrintouts, name)) {
                                                printouts.push({
                                                    getId: function() { return name; },
                                                    getModelClass: function() { return name; }
                                                });
                                            }
                                        });

                                        return printouts;
                                    }
                                });
                            },
                            showFn: tabShowFn
                        }
                    ]
                },
                {
                    title: 'Notes',
                    sections: [
                        {
                            name: 'visitnotes',
                            label: 'Visit',
                            initFn: function($container, name) {
                                createAttachmentFeed({
                                    container: $container,
                                    name: name,
                                    url: el8Globals['PATIENT_PATH'] + 'chart-feed-index/',
                                    preProcessFeedFn: function(index) {
                                        return index.reduce(function(filteredNotes, feedItem) {
                                            if (feedItem.model_class.match(/^VisitNote[2]?$/) !== null &&
                                                el8.util.isNone(feedItem.document_sub_type)) {

                                                if (feedItem.model_class === "VisitNote2") {
                                                    // Chart feed index includes VN1s and VN2s, but not backported VN1s
                                                    // Filter for VN1 notes and VN2 backports, as we only support attachments for VN1.
                                                    // For the case of VN2s we'll instead surface the backported VN1
                                                    // el8.ptdata.fetch will fetch the backported VN1 if not cached
                                                     filteredNotes.push({ id: feedItem.note_v1_id });
                                                } else {
                                                     filteredNotes.push(feedItem);
                                                } 
                                            }

                                            return filteredNotes;
                                        }, []);
                                    }
                                });
                            },
                            showFn: tabShowFn
                        },
                        {
                            name: 'nonvisitnotes',
                            label: 'Other Notes',
                            initFn: function($container, name) {
                                createAttachmentFeed({
                                    container: $container,
                                    name: name,
                                    url: el8Globals['PATIENT_PATH'] + 'chart-feed-index/',
                                    preProcessFeedFn: function(index) {
                                        return index.filter(function(feedItem) {
                                            return (feedItem.model_class.indexOf('NonvisitNote') !== -1 &&
                                                    el8.util.isNone(feedItem.document_sub_type));
                                        });
                                    }
                                });
                            },
                            showFn: tabShowFn
                        }
                    ]
                },
                {
                    title: 'Reports',
                    sections: [] // will be dynamically populated below
                },
                {
                    title: 'Orders',
                    sections: [
                        {
                            name: 'referral-orders',
                            label: 'Referral Orders',
                            initFn: createAttachmentOrderFeed,
                            showFn: tabShowFn
                        },
                        {
                            name: 'lab-orders',
                            label: 'Lab Orders',
                            initFn: createAttachmentOrderFeed,
                            showFn: tabShowFn
                        },
                        {
                            name: 'imaging-orders',
                            label: 'Imaging Orders',
                            initFn: createAttachmentOrderFeed,
                            showFn: tabShowFn
                        },
                        {
                            name: 'cardiac-orders',
                            label: 'Cardiac Orders',
                            initFn: createAttachmentOrderFeed,
                            showFn: tabShowFn
                        },
                        {
                            name: 'pulmonary-orders',
                            label: 'Pulmonary Orders',
                            initFn: createAttachmentOrderFeed,
                            showFn: tabShowFn
                        },
                        {
                            name: 'sleep-orders',
                            label: 'Sleep Orders',
                            initFn: createAttachmentOrderFeed,
                            showFn: tabShowFn
                        }
                    ]
                },
                {
                    title: 'Other',
                    sections: [
                        {
                            name: 'handouts',
                            label: 'Patient Handouts',
                            initFn: function($container, name) {
                                /* Preload all the handouts so they're cached. This will mean
                                 * two calls to /handouts/ (since we also use the URL as our feed index),
                                 * but that is better than a bunch of synchronous calls to fetch each
                                 * handout individually. */
                                el8.data.educationalHandouts.load();

                                createAttachmentFeed({
                                    container: $container,
                                    name: name,
                                    url: el8.service.urls.get('getEducationalHandouts'),
                                    fetchFn: function(arg, force, async, callbackFn) {
                                        /* This fetchFn is somewhat of a hack, since we don't have an el8.data.fetch.
                                         * It relies on el8.data.educationalHandouts.getById, but that means
                                         * it doesn't respect the async args */
                                        var results;
                                        if (!(arg instanceof Array)) { arg = [arg]; }

                                        var fetchHandouts = function() {
                                            var idArgs = _.pluck(arg, 'id');
                                            results = idArgs.map(function(id) {
                                                return el8.data.educationalHandouts.getById(id);
                                            });
                                            if (callbackFn) { callbackFn(results); }
                                        };

                                        if (force) {
                                            // if force is true, reload the handout set first, then use getById
                                            el8.data.educationalHandouts.load(fetchHandouts);
                                        } else {
                                            fetchHandouts();
                                        }
                                        return results;
                                    },
                                    urlFilter: el8.service.urls.get('getEducationalHandouts'),
                                    filterFieldSelector: ':input[name="search"]',
                                    filterFieldInfoText: 'Search handouts by name or tag...',
                                    filterBtn: '.search-trigger',
                                    clearFilterBtn: '.clear-search-trigger',
                                    filteredClass: 'el8AttachmentFilteredResults'
                                });
                            },
                            showFn: tabShowFn
                        },
                        {
                            name: 'messages',
                            label: 'Office Messages',
                            initFn: function($container, name) {
                                createAttachmentFeed({
                                    container: $container,
                                    name: name,
                                    url: el8Globals['PATIENT_PATH'] + 'chart-feed-index/',
                                    preProcessFeedFn: function(index) {
                                        return index.filter(function(feedItem) {
                                            return (feedItem.model_class === 'MessageThread');
                                        });
                                    }
                                });
                            },
                            showFn: tabShowFn
                        },
                        {
                            name: 'letters',
                            label: 'Letters',
                            initFn: function($container, name) {
                                createAttachmentFeed({
                                    container: $container,
                                    name: name,
                                    url: el8Globals['PATIENT_PATH'] + 'chart-feed-index/',
                                    preProcessFeedFn: function(index) {
                                        return index.filter(function(feedItem) {
                                            // Letters and LetterReceipts
                                            var rv = _.contains(['Letter', 'LetterReceipt'], feedItem.model_class);
                                            if (rv && ('Letter' === feedItem.model_class)) {
                                                // for letter, we need to check if this is a referral letter
                                                // if true, then the referral already shows up in the referral order section and should not show up here
                                                var feedItemDetail = el8.ptdata.fetchById(feedItem.id);
                                                if (feedItemDetail && feedItemDetail.isReferralLetter()) {
                                                    return false;
                                                }
                                            }
                                            return rv;
                                        });
                                    }
                                });
                            },
                            showFn: tabShowFn
                        }
                    ]
                }
            ];

            // add all the currently available report types
            var reportTypeIds = el8.appchart.reportFeeds.main.getCurrentReportTypeIds();
            result[2]['sections'] = reportTypeIds.map(this.getReportFeedSpec);

            if (el8Globals.FEATURES.PrenatalFlowsheets) {
                var prenatalfs = {
                    name: 'prenatalfs',
                    label: 'Flowsheets',
                    initFn: function($container, name) {
                        createAttachmentFeed({
                            container: $container,
                            name: name,
                            url: el8.service.urls.get('prenatalFlowsheets'),
                            preProcessFeedFn: function(index) {
                                return index;
                            }
                        });
                    },
                    showFn: tabShowFn
                };
                result[1]['sections'].push(prenatalfs);
            }

            return result;
        },

        getReportFeedSpec: function(rTypeId) {
            var rType = el8Globals.AVAILABLE_REPORT_TYPES[rTypeId];
            return {
                name: el8.appchart.reportFeeds.main.getReportTypeFromId(rTypeId),
                label: rType.nickname,
                initFn: createAttachmentReportFeed,
                showFn: tabShowFn
            };
        },

        getFeedByName: function(name) {
            return (feedList[name]) ? feedList[name] : null;
        },

        setIsAttachedFn: function(callbackFn) {
            isAttachedFn = callbackFn;
        }
    };

})();
